export default function () {
	document.addEventListener('DOMContentLoaded', function () {
		const isCheckoutPage = () => {
			const formCheckout = document.querySelector('form.checkout')
			return formCheckout && document.body.classList.contains('woocommerce-checkout')
		}

		if (!isCheckoutPage()) return

		const getGoogleConsentStatus = (consentType) => {
			if (
				window.google_tag_data &&
				window.google_tag_data.ics &&
				typeof window.google_tag_data.ics.getConsentState === 'function'
			) {
				const consentState = window.google_tag_data.ics.getConsentState(consentType)
				switch (consentState) {
					case 1:
						return 'granted'
					case 2:
						return 'denied'
					default:
						return 'unknown'
				}
			} else {
				console.warn('Google Consent API (google_tag_data) is not available yet.')
				return 'unavailable'
			}
		}

		try {
			const injectGAFields = () => {
				const consentStatus = getGoogleConsentStatus('analytics_storage')
				updateOrCreateHiddenInput('ga_consent_status', consentStatus)

				if (consentStatus === 'granted' && typeof gtag === 'function') {
					gtag('get', window.webixa.GA4_MEASUREMENT_ID, 'client_id', (clientId: string) => {
						updateOrCreateHiddenInput('ga_client_id', clientId)
					})
					gtag('get', window.webixa.GA4_MEASUREMENT_ID, 'session_id', (sessionId: string) => {
						updateOrCreateHiddenInput('ga_session_id', sessionId)
					})
					gtag('get', window.webixa.GA4_MEASUREMENT_ID, 'session_number', (sessionNumber: string) => {
						updateOrCreateHiddenInput('ga_session_number', sessionNumber)
					})
				} else {
					updateOrCreateHiddenInput('ga_client_id', '')
					updateOrCreateHiddenInput('ga_session_id', '')
				}
			}

			const updateOrCreateHiddenInput = (name: string, value: string) => {
				const form = document.querySelector('form.checkout')
				if (!form) return

				let input = form.querySelector('input[name="' + name + '"]')
				if (!input) {
					input = document.createElement('input')
					input.type = 'hidden'
					input.name = name
					form.appendChild(input)
				}
				input.value = value
			}

			injectGAFields()
			jQuery(document.body).on('updated_checkout', injectGAFields)
		} catch (e) {
			console.error('Error during fetching GA4 data:', e)
		}
	})
}
